'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _awaitingreview = require('./awaitingreview.html');

var _awaitingreview2 = _interopRequireDefault(_awaitingreview);

var _awaitingreview3 = require('./awaitingreview.controller');

var _awaitingreview4 = _interopRequireDefault(_awaitingreview3);

require('./awaitingreview.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var awaitingreviewComponent = {
  restrict: 'E',
  bindings: {},
  template: _awaitingreview2.default,
  controller: _awaitingreview4.default,
  controllerAs: 'vm'
};

exports.default = awaitingreviewComponent;


// WEBPACK FOOTER //
// ./client/app/common/reports/awaitingreview/awaitingreview.component.js